<div class="create-account-container">
  <!-- Left side - Create Account Form -->
  <div class="form-container">
    <div class="form-content">
      <div class="header">
        <h1>Create Account</h1>
        <p>Sign in to access your ScholarX workspace!</p>
      </div>

      <!-- <div class="role-toggle">
        <button 
          [class.active]="!isTeacher" 
          (click)="toggleRole(false)"
          class="toggle-button">
          As Student
        </button>
        <button 
          [class.active]="isTeacher" 
          (click)="toggleRole(true)"
          class="toggle-button">
          As Tutor
        </button>
      </div> -->

      <form [formGroup]="createAccountForm" (ngSubmit)="onSubmit()" class="create-account-form">
        <div class="form-row">
          <div class="form-group">
            <label for="fullName">Full Name</label>
            <input 
              id="fullName" 
              type="text" 
              formControlName="fullName" 
              placeholder="Enter"
            />
          </div>
          <div class="form-group">
            <label for="id">ID</label>
            <input 
              id="id" 
              type="text" 
              formControlName="id" 
              placeholder="Enter"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="schoolPasskey">School Passkey</label>
            <input 
              id="schoolPasskey" 
              type="text" 
              formControlName="schoolPasskey" 
              placeholder="Enter"
            />
          </div>
          <div class="form-group">
            <label for="contactNumber">Contact Number</label>
            <input 
              id="contactNumber" 
              type="tel" 
              formControlName="contactNumber" 
              placeholder="Enter"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="email">Email Address</label>
            <input 
              id="email" 
              type="email" 
              formControlName="email" 
              placeholder="Enter"
            />
          </div>
          <div class="form-group">
            <label for="password">Create Password</label>
            <input 
              id="password" 
              type="password" 
              formControlName="password" 
              placeholder="Enter"
            />
          </div>
        </div>

        <div  class="professional-details">
          <h2>Professional Details</h2>
          
          <div class="form-row">
            <div class="form-group">
              <label for="gradeLevels">Grade Levels You Teach</label>
              <input 
                id="gradeLevels" 
                type="text" 
                formControlName="gradeLevels" 
                placeholder="Enter"
              />
            </div>
            <div class="form-group">
              <label for="subjects">Subjects You Teach</label>
              <input 
                id="subjects" 
                type="text" 
                formControlName="subjects" 
                placeholder="Enter"
              />
            </div>
          </div>

          <div class="form-group">
            <label for="classTutor">Class Tutor</label>
            <input 
              id="classTutor" 
              type="text" 
              formControlName="classTutor" 
              placeholder="Enter"
            />
          </div>
        </div>

        <button 
          type="submit" 
          class="submit-button" 
          [disabled]="!createAccountForm.valid || isLoading">
          {{ isLoading ? 'Creating Account...' : 'Log In →' }}
        </button>

        <div *ngIf="error" class="error-message">
          {{ error }}
        </div>
      </form>

      <div class="copyright">
        © ScholarX.ai, All rights reserved.
      </div>
    </div>
  </div>

  <!-- Right side - Marketing Content -->
  <div class="marketing-container">
    <div class="marketing-content">
      <img src="assets/ScholarX_Logo_Icon.svg" alt="ScholarX Logo" class="logo" />
      
      <div class="marketing-text">
        <h2>Instant explanations, study tips, and interactive practice.</h2>
        <p>
          Get real-time answers to all your questions, whether they are related to your syllabus or
          beyond, easy-to-understand explanations tailored to your grade level and curriculum.
        </p>
      </div>

      <div class="preview-image">
        <img src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Create%20Account%20-%20Teachers-NRaPxl6Xzdj9MFkeTu3FRkjRj5rULZ.png" alt="ScholarX Interface Preview" />
      </div>
    </div>
  </div>
</div>

